import { Flex, Typography } from "antd"
import dayjs from "dayjs"

import Private from "../../../../Components/Private"
import { formatCurrency } from "../../../../Utils/utils"
import { referralColorMap, referralTextMap } from "../../utils/constants"

const { Text } = Typography

const ReferralBAInfo = ({ data }) => {
  const date = dayjs(data?.creation_date)
  const dateFormatted = date.format("D MMM YYYY h:mm A") + " (UTC)"
  return (
    <Flex justify="space-between" gap={10}>
      <Flex vertical gap={8}>
        <Text type="secondary">Total number of alerts </Text>
        <Text type="secondary">Reward </Text>
        <Text type="secondary">Creation date </Text>
        <Text type="secondary">User created </Text>
        <Text type="secondary">Business account </Text>
        <Text type="secondary">BA status </Text>
      </Flex>
      <Flex vertical gap={8}>
        <Text strong>{(data?.total_alerts ?? 0).toLocaleString()}</Text>
        <Text strong>
          <Private>{formatCurrency((data?.reward ?? 0) / 100)}</Private>
        </Text>
        <Text strong>{dateFormatted}</Text>
        <Text strong>{data?.user_created ?? "-"}</Text>
        <Text strong>
          <Private>{data?.business_account ?? "-"}</Private>
        </Text>
        <Text strong style={{ color: referralColorMap[data?.ba_status] }}>
          {referralTextMap[data?.ba_status] ?? data?.ba_status ?? "-"}
        </Text>
      </Flex>
    </Flex>
  )
}

export default ReferralBAInfo
